<template>
    <!--todo 搜尋匹配套件 https://element.eleme.io/#/zh-CN/component/input-->
    <!--搜尋清空時要回到篩選頁-->
    <form action="javascript:return true">
        <el-autocomplete
            placeholder="關鍵字請至少輸入兩個字"
            :fetch-suggestions="querySearch"
            :trigger-on-focus="false"
            class="search-input"
            v-model="input"
            type="search"
            ref="search"
            @keyup.enter.native="handleClick"
            @clear="handleClear"
            clearable>
        </el-autocomplete>
    </form>
</template>

<script>
    export default {
        name: "SearchBar",
        props:{
            search: {
                type: String,
                default: ''
            }
        },
        // model:{
        //     prop: "name",        //v-model 的寫法，參數 prop 是指定要綁定哪一個 prop
        //     event: "update",     //參數 event 是指定在父元素會監聽哪個事件名稱
        // },
        data() {
            return {
                restaurants: [],
                input:'',//搜尋
            }
        },
        created() {

        },
        mounted() {
            this.input = this.search;
            //一進入搜尋頁就開啟鍵盤focus
            //this.$refs.search.focus()
            if(this.$route.name ==='Search'){
                this.$refs.search.focus()
            }
            //搜尋匹配用
            this.restaurants = this.loadAll();
        },
        methods: {
            //input鍵盤監聽
            handleClick(){

                if (this.input.length > 1) {
                    //鍵盤送出後自動關閉焦點
                    let focusedElement = document.activeElement;
                    focusedElement.blur();
                    this.$emit(`searchWord`, this.input);
                }

                // this.$router.push({name: 'SearchList'})
            },
            //搜尋匹配用
            querySearch(queryString, cb) {
                var restaurants = this.restaurants;
                var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            //搜尋匹配用
            createFilter(queryString) {
                return (restaurant) => {
                    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            handleClear(){
                //在搜尋商家列表按關閉返回進階搜尋
                if(this.$route.name ==='SearchList'){
                    this.$router.go(-1);
                    this.$refs.search.focus()
                }
            },
            loadAll() {
                return [
                    { "value": "三媽臭臭"},
                    { "value": "晨間廚房"},
                    { "value": "麥味登"},
                    { "value": "早餐店"},
                    { "value": "早午餐"},
                    { "value": "早午餐2"},
                    { "value": "早午餐3"},
                    { "value": "早午餐4"},
                    { "value": "早安山丘"},
                    { "value": "早安山丘2"},
                    { "value": "早安山丘3"},
                    { "value": "早安山丘4"},
                    { "value": "早安山丘5"},
                ];
            },
        },
    }
</script>

<style lang="less" scoped src="../../../less/search.less"/>
